import React from "react";

const projectShowcase = [
  { title: "Loopline Studio", detail: "Immersive scoring tools for live events." },
  { title: "Atlas Insight", detail: "AI research co-pilot for customer intelligence." },
  { title: "Spark Grid", detail: "Autonomous automation matrix for ops teams." },
  { title: "Pulse Desk", detail: "Real-time conversation intelligence for support." }
];

const styles = {
  leanSection: {
    maxWidth: 1100,
    margin: "32px auto",
    padding: "0 1.5rem",
    textAlign: "center"
  },
  sectionTitle: {
    margin: 0,
    fontSize: "2.5rem",
    fontWeight: 700,
    color: "white"
  },
  sectionSubhead: {
    marginTop: 8,
    color: "white",
    maxWidth: 760,
    lineHeight: 1.6,
    textAlign: "center",
    marginLeft: "auto",
    marginRight: "auto"
  },
  projectGrid: {
    marginTop: 32,
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: 18,
    justifyContent: "center"
  },
  projectCard: {
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: 18,
    padding: "1.5rem",
    background: "rgba(255,255,255,0.03)",
    minHeight: 160,
    boxShadow: "0 20px 40px rgba(0,0,0,0.35)"
  },
  cardText: {
    color: "#B0B6C7",
    lineHeight: 1.6
  }
};

const ProjectsPage = () => (
  <section style={styles.leanSection}>
    <h2 style={styles.sectionTitle}>Projects</h2>
    <p style={styles.sectionSubhead}>
      A sampling of the bots, platforms, and experiences actively evolving inside TwoDots.
    </p>
    <div style={styles.projectGrid}>
      {projectShowcase.map((project) => (
        <article key={project.title} style={styles.projectCard}>
          <h3 style={{ marginBottom: 8 }}>{project.title}</h3>
          <p style={styles.cardText}>{project.detail}</p>
        </article>
      ))}
    </div>
  </section>
);

export default ProjectsPage;
